import request from "../utils/request";
import gdReuest from "../utils/requestGaoding";

/**
 * 检测用户是否在某些分群
 * @param {{group_ids: string[], cookie?: string}}
 * @returns
 */
export async function checkUserGroup({ group_ids, cookie }) {
  return request({
    url: "/user-profile-proxy/user-group/validate-all",
    query: {
      group_ids: group_ids?.join(","),
    },
    headers: cookie
      ? {
          cookie,
        }
      : {},
  });
}

/**
 * 获取用户关注用户
 * @param {number} urlname 用户urlname
 * @returns
 */
/**
 * @param {{
 *   urlname: any;
 *   q?: string;
 *   page?: number;
 *   has_collection?: number;
 *   max?: number;
 *   limit?: number;
 * }} query
 * @returns {Promise<*|{msg: string, err: number}|undefined>}
 */
export async function getFollowingUsers({
  urlname,
  limit,
  max,
  page,
  has_collection,
  q,
}) {
  return request({
    url: `/${urlname}/following`,
    query: {
      limit,
      max,
      page,
      has_collection,
      q,
    },
    noParse: true,
  });
}

/**
 * 获取用户关注用户
 * @param {number} urlname 用户urlname
 * @returns
 */
/**
 * @param {{
 *   urlname: string;
 *   params?: {
 *     deleted_board_count: number;
 *   };
 * }} query
 * @returns {Promise<*|{msg: string, err: number}|undefined>}
 */
export async function getUserCount({ urlname, params }) {
  return request({
    url: `/${urlname}/user_counts`,
    query: params,
  });
}

/**
 * 获取用户粉丝
 * @param {number} urlname 用户urlname
 * @returns
 */
export async function getFollowerUsers({ urlname, limit, max }) {
  return request({
    url: `/${urlname}/followers`,
    query: {
      limit,
      max,
    },
    noParse: true,
  });
}

/**
 * 关注用户
 * @param {string} urlname 用户urlname
 * @returns
 */
export async function followUser(urlname) {
  return request({
    method: "post",
    url: `/${urlname}/follow`,
    noParse: true,
  });
}

/**
 * 取消关注用户
 * @param {string} urlname 用户urlname
 * @returns
 */
export async function unfollowUser(urlname) {
  return request({
    method: "post",
    url: `/${urlname}/unfollow`,
    noParse: true,
  });
}

/**
 * 获取用户的全部标签
 * @param {{
 *  urlname: string
 *  sort?: 'often'
 *  limit?: number
 * }} urlname
 * @returns {Promise<{
 *   tags: {
 *     tag_name: string
 *     count: number
 *   }[]
 *   recent: {
 *     tag_name: string
 *     count: number
 *   }[],
 *   err: number
 * }>}
 */
export async function getTags({ urlname, sort, limit }) {
  return request({
    url: `/${urlname}/tags`,
    query: {
      sort,
      limit: limit ?? 10,
    },
    noParse: true,
  });
}

/**
 * 删除标签
 * https://yapi.gaoding.com/project/1536/interface/api/116953
 *
 * @param tags
 * @returns {Promise<any|undefined>}
 */
export async function deleteTags({ tags }) {
  return request({
    method: "delete",
    url: "/pin/tags",
    data: { tags },
  });
}

/**
 * 更新标签
 * https://yapi.gaoding.com/project/1536/interface/api/116953
 *
 * @param old_tags
 * @param new_tags
 * @returns {Promise<any|undefined>}
 */
export async function updateTags({ old_tags, new_tags }) {
  return request({
    method: "put",
    url: "/pin/tags",
    data: { old_tags, new_tags },
  });
}

/**
 * 获取标签对应的采集
 * https://yapi.gaoding.com/project/1536/interface/api/115833
 * @param username
 * @param tag_name
 * @returns {Promise<any|undefined>}
 */
export async function getRelatedPinsByTag({ username, tag_name }) {
  return request({
    url: `/${username}/tags/${tag_name}/pins`,
    noParse: true,
  });
}

/**
 * 获取某用户画板list
 * https://yapi.gaoding.com/project/1536/interface/api/116278
 * @param {
 *   username: string
 *   max?: number,
 *   limit?: number
 *   all?: boolean,
 *   since?: number,
 *   order_by_updated?: boolean,
 *   extra?: any,
 *   page?: number,
 *   per_page?: number,
 * }
 * @returns {Promise<any|undefined>}
 */
export async function getUserBoards({
  username,
  max,
  limit,
  all,
  order_by_updated,
  extra,
  q,
  page,
  per_page,
  ...query
}) {
  return request({
    url: `/${username}/boards`,
    query: {
      max,
      limit,
      all,
      order_by_updated,
      extra,
      q,
      page,
      per_page,
      fields: "boards:BOARD|user,total,page_num,page_size",
      ...query,
    },
    noParse: true,
  });
}

/**
 * 获取原创画板
 * https://yapi.gaoding.com/project/1536/interface/api/116933
 * @param {{
 *   urlname: string,
 *   max?: number,
 *   limit?: number,
 *   since?: number,
 *   order_by?: string,
 * }} params
 * @returns {Promise<any|undefined>}
 */
export async function getMuseBoards({ urlname, max, limit, since, order_by }) {
  return request({
    url: `/${urlname}/muse_boards`,
    query: {
      max,
      limit,
      since,
      order_by,
    },
    noParse: true,
  });
}

/**
 * 获取专辑对应的画板
 * https://yapi.gaoding.com/project/1536/interface/api/116336
 * @param {{
 *    urlname: string,
 *    collection_id?: string,
 *    max?: number,
 *    limit?: number,
 * }}
 * @returns {Promise<any|undefined>}
 */
export async function getCollectionBoards({
  username,
  collection_id,
  max,
  limit,
}) {
  return request({
    url: `/${username}/collections/${collection_id}`,
    query: { max, limit },
    noParse: true,
  });
}

/**
 * 获取用户采集
 * https://yapi.gaoding.com/project/1536/interface/api/116279
 *
 * @param username
 * @param max
 * @param since
 * @param limit
 * @param q
 * @param per_page
 * @param page
 * @returns {Promise<*|undefined>}
 */
export async function getUserPins({
  username,
  max,
  since,
  limit,
  q,
  sort,
  bl_filter,
  per_page,
  page,
  ...query
}) {
  return request({
    url: `/${username}/pins`,
    query: {
      max,
      since,
      limit,
      q,
      bl_filter,
      per_page,
      page,
      sort,
      fields: "pins:PIN|total,page_num,page_size",
      ...query,
    },
    noParse: true,
  });
}

/**
 * 获取原创画板
 * https://yapi.gaoding.com/project/1536/interface/api/118309
 * @param username
 * @param max
 * @param since
 * @param limit
 * @returns {Promise<any|undefined>}
 */
export async function getMUserPins({ username, max, since, limit }) {
  return request({
    url: `/${username}/muse_pins`,
    query: {
      max,
      since,
      limit,
    },
    noParse: true,
  });
}

/**
 * 获取用户喜欢的采集
 * https://yapi.gaoding.com/project/1536/interface/api/116756
 * @param username
 * @param max
 * @param limit
 * @param since
 */
export async function getUserFavoritePins({ username, max, limit, since }) {
  return request({
    url: `/${username}/likes`,
    query: { max, limit, since },
    noParse: true,
  });
}

/**
 * 获取用户喜欢的画板
 * https://yapi.gaoding.com/project/1536/interface/api/116757
 * @param username
 * @param max
 * @param limit
 * @param since
 * @returns {Promise<any|undefined>}
 */
export async function getUserFavoriteBoards({
  username,
  max,
  limit,
  since,
  ignoreMessage,
}) {
  return request({
    url: `/${username}/likes/boards`,
    query: {
      max,
      limit,
      since,
    },
    ignoreMessage,
    noParse: true,
  });
}

/**
 * 获取用户信息
 * https://yapi.gaoding.com/project/1536/interface/api/115800
 * @param {{
 *  user_id?: string|number,
 *  urlname?: string,
 *  ignoreMessage?: boolean,
 * }} { user_id, urlname, ignoreMessage }
 * @returns {Promise<*|undefined>}
 */
export async function getUser({ user_id, urlname, ignoreMessage }) {
  if (user_id) {
    return request({
      url: `/user/${user_id}`,
      ignoreMessage,
      noParse: true,
    });
  } else if (urlname) {
    return getUserFavoriteBoards({
      username: urlname,
      limit: 0,
      ignoreMessage,
      noParse: true,
    });
  }
}

/**
 * 获取标签对应的采集
 * https://yapi.gaoding.com/project/1536/interface/api/115833
 * @param urlname
 * @param tag_name
 * @returns {Promise<{msg: string, err: number}|any|undefined>}
 */
export async function getPinsByTag({
  urlname,
  tag_name,
  since,
  max,
  limit,
  page,
}) {
  return request({
    url: `/${urlname}/tags/${tag_name}/pins`,
    query: {
      since,
      max,
      limit,
      page,
    },
    noParse: true,
  });
}

/**
 * 获取偏好用户
 * @returns {AxiosPromise}
 */
export function getFavoriteUsers({ urlname, limit, max, since }) {
  return request({
    url: `/users/favorite/${urlname}`,
    query: {
      limit,
      max,
      since,
    },
    noParse: true,
  });
}

/**
 * 获取已提交的申请认证设计师表单
 * https://yapi.gaoding.com/project/1536/interface/api/136257
 * @returns {Promise<*|undefined>}
 */
export async function getMuseRegisterInfo() {
  return request({
    url: "/muse/certify",
  });
}

/**
 * 提交认证设计师申请
 * https://yapi.gaoding.com/project/1536/interface/api/136250
 * @param data
 * @returns {Promise<*|undefined>}
 */
export async function postMuseRegisterInfo(data) {
  return request({
    method: "post",
    url: "/muse/register",
    data,
    noParse: true,
  });
}
/**
 * 获取推荐用户
 * https://yapi.gaoding.com/project/1536/interface/api/156358
 * @param data
 * @returns {Promise<*|undefined>}
 */
export async function getRecommendUsers({ limit, max, since, page }) {
  return request({
    url: "/recommend/hot/users",
    query: {
      limit,
      max,
      since,
      page,
    },
  });
}

export async function checkNeedRestPassword({ tel }) {
  return request({
    url: `/tels/${tel}/check`,
  });
}

/**
 * 获取当前用户权限
 * @param {string} app_codes
 * @returns {string[]}
 */
export async function getUserPermissions(app_codes = "gdesign") {
  return gdReuest({
    url: `/structure/user/permissions`,
    query: {
      app_codes,
    },
  }).then((res) => {
    if (Array.isArray(res)) {
      return res.find((item) => item.app_code === app_codes)?.codes || [];
    }

    return [];
  });
}

/**
 * 获取职业列表
 */
export async function getJobList() {
  return request({
    url: `/v2/config?field=jobs`,
  });
}

/**
 * 获取职业、行业标签（轻舟配置）
 * @returns {Promise<{jobs: ICrowdTag[],industry: ICrowdTag[]}>}
 */
export async function getCrowdTags() {
  return request({
    url: "/coms/v2/crowd-tags",
  });
}
